import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);
const mql = typeof window !== "undefined" && window.matchMedia ? window.matchMedia("(prefers-color-scheme: dark)") : null;

// mode: "light" | "dark" | "system"; theme: resolved "light" | "dark"
export function ThemeProvider({ children }) {
  const [mode, setMode] = useState(() => (typeof window === "undefined" ? "light" : localStorage.getItem("rw-theme") || "light"));
  const [systemDark, setSystemDark] = useState(() => !!mql?.matches);
  const theme = mode === "system" ? (systemDark ? "dark" : "light") : mode;

  useEffect(() => {
    if (!mql) return undefined;
    const on = (e) => setSystemDark(e.matches);
    mql.addEventListener?.("change", on);
    return () => mql.removeEventListener?.("change", on);
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("dark", theme === "dark");
    root.style.colorScheme = theme;
    document.querySelector("meta[name='theme-color']")?.setAttribute("content", theme === "dark" ? "#0A1424" : "#001A38");
    localStorage.setItem("rw-theme", mode);
    window.dispatchEvent(new Event("rw-theme-change"));
  }, [theme, mode]);

  const toggle = () => setMode(theme === "dark" ? "light" : "dark");

  return (
    <ThemeContext.Provider value={{ theme, mode, setMode, setTheme: setMode, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme must be used inside ThemeProvider");
  return ctx;
}
